/* src/app/components/lead-details/prospective-participants/prospective-participants/prospective-participants.component.css */
/*# sourceMappingURL=prospective-participants.component-AWP2RHJ7.css.map */
